import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name heart-x
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTUuNSAxMi41IDUgNSIgLz4KICA8cGF0aCBkPSJtMjAuNSAxMi41LTUgNSIgLz4KICA8cGF0aCBkPSJNMjEuOTU1IDguNzc0YTUuNSA1LjUgMCAwIDAtOS41NDYtMi45NS42LjYgMCAwIDEtLjgxOCAwQTUuNSA1LjUgMCAwIDAgMiA5LjVjMCAyLjMgMS41IDQgMyA1LjVsNS41MDggNS4zMzJhMiAyIDAgMCAwIDIuNTcuMzUyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/heart-x
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const HeartX: IconNode = [
  ['path', { d: 'm15.5 12.5 5 5' }],
  ['path', { d: 'm20.5 12.5-5 5' }],
  [
    'path',
    {
      d: 'M21.955 8.774a5.5 5.5 0 0 0-9.546-2.95.6.6 0 0 1-.818 0A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.508 5.332a2 2 0 0 0 2.57.352',
    },
  ],
];

export default HeartX;
